import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { formatVariantsText } from "../constants";
import VariantsPricingModal from "./VariantsPricingModal";

const VariantsCell = ({
  variants,
  onVariantChange,
  onVariantsChange,
  productSkus = [],
  inTable = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const hasVariants = variants && variants.length > 0;
  const canOpen = hasVariants || productSkus.length > 0;

  if (!canOpen) {
    return (
      <Typography
        fontSize="12px"
        color="var(--text-tertiary)"
        fontFamily="Poppins"
      >
        —
      </Typography>
    );
  }

  const text = hasVariants ? formatVariantsText(variants) : null;

  return (
    <>
      {inTable ? (
        <Box
          onClick={() => setModalOpen(true)}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "flex-start",
            minHeight: "50px",
            px: 1,
            py: 0.5,
            width: "100%",
            overflow: "hidden",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.04)" },
          }}
        >
          <Typography
            fontSize="12px"
            fontFamily="Poppins"
            color={hasVariants ? "var(--text-primary)" : "var(--text-tertiary)"}
            sx={{
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              lineHeight: 1.4,
              fontStyle: hasVariants ? "normal" : "italic",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            {text || "No SKUs mapped"}
          </Typography>
        </Box>
      ) : (
        <Box
          onClick={() => setModalOpen(true)}
          sx={{
            cursor: "pointer",
            px: 1,
            py: 0.75,
            borderRadius: 1,
            border: "1px solid var(--border-color)",
            backgroundColor: "var(--bg-secondary, var(--bg-paper))",
            "&:hover": { borderColor: "primary.main" },
          }}
        >
          <Typography
            fontSize="12px"
            fontFamily="Poppins"
            color={hasVariants ? "var(--text-primary)" : "var(--text-tertiary)"}
            sx={{
              wordBreak: "break-word",
              fontStyle: hasVariants ? "normal" : "italic",
              textAlign: "left",
            }}
          >
            {text || "No SKUs mapped"}
          </Typography>
        </Box>
      )}
      <VariantsPricingModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        variants={variants || []}
        onVariantChange={onVariantChange}
        onVariantsChange={onVariantsChange}
        productSkus={productSkus}
      />
    </>
  );
};

export default VariantsCell;
